export const EMAIL_RELATED_ERROR_CODES_FOR_SIGNUP = [
  'brand_manager.signup.nonunique_email',
  'brand_manager.signup.unverified_account',
  'brand_manager.signup.invalid_email_domain',
]

export const DUPLICATE_TIKTOK_ACCOUNT_ERROR = 'brand_identity.create.duplicate_accounts_error'
